const FBTURLMap = new Map([
    ["mb1-bracket", "mb1-bracket"],
    ["mb6", "mb6"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"],
    ["mb1-p", "mb1-p"],
    ["mb3u", "mb3u"],
    ["mb3", "mb3"],
    ["mb5",  "mb5"],
    ["mb2", "mb2"],
    ["mb-pb-premium-base-mounting-bracket", "mb-pb-premium-base-mounting-bracket"],
    ["mb8-bracket", "mb8-bracket"],
    ["mb14-bracket", "mb14-bracket"],
    ["mb9-bracket", "mb9-bracket"],
    ["mb6-p-bracket", "mb6-p-bracket"],
    ["mb50u-mounting-bracket", "mb50u-mounting-bracket"],
    ["mb36sm", "mb36sm"],
    ["mb50", "mb50"],
    ["pulley-lifting-cables-for-linear-actuators", "pulley-lifting-cables-for-linear-actuators"],
    ["mb36", "mb36"],
    ["mb36c", "mb36c"],
    ["mb50c", "mb50c"],
    ["mb35-mounting-bracket", "mb35-mounting-bracket"],
    ["mb7", "mb7"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "mb-17-mounting-bracket-for-super-duty-actuators"],
    ["synchronous-control-board", "synchronous-control-board"],
    ["rocker-switch-momentary" , "rocker-switches-for-linear-actuators-momentary-and-sustaining"],
    ["rocker-switch-sustaining", "rocker-switches-for-linear-actuators-momentary-and-sustaining"],
    ["toggle-switch-momentary", "toggle-switch"],
    ["toggle-switch-sustaining", "toggle-switch"],
    ["two-channel-remote-control-system", "two-channel-remote-control-system"],
    ["four-channel-remote-control-system", "four-channel-remote-control-system"],
    ["external-limit-switch-kit-for-actuators", "external-limit-switch-kit-for-actuators"],
    ["dc-power-adaptor", "dc-power-adaptor"],
    ["ac-to-dc-power-adaptor-12v-30a", "ac-to-dc-power-adaptor-12v-30a"],
    ["mb18-mounting-brackets", "mb18-mounting-brackets"]
]);

const FBTNameMap = new Map([
    ["mb1-bracket", "MB1 Bracket"],
    ["mb6", "MB6 Body Bracket"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "MB10 Bracket for Rod end actuators"],
    ["mb1-p", "MB1-P Mounting Bracket for P-series Actuator"],
    ["mb3u", "MB3U Bracket"],
    ["mb3", "MB3 Bracket"],
    ["mb5",  "MB5 Bracket"],
    ["mb2", "MB2 Bracket"],
    ["mb-pb-premium-base-mounting-bracket", "P-series Base Mounting Bracket"],
    ["mb8-bracket", "MB8 Bracket"],
    ["mb14-bracket", "MB14 Bracket"],
    ["mb9-bracket", "MB9 Bracket"],
    ["mb6-p-bracket", "MB6-P body brackets for P-series actuators"],
    ["mb50u-mounting-bracket", "MB50U Mounting Bracket"],
    ["mb36sm", "MB36SM Mounting Bracket"],
    ["mb50", "MB50 Mounting Bracket"],
    ["pulley-lifting-cables-for-linear-actuators", "Pulley Lifting Cables for Linear Actuators"],
    ["mb36", "MB36 Mounting Bracket"],
    ["mb36c", "MB36C Mounting Clamp Bracket"],
    ["mb50c", "MB50C Mounting Clamp Bracket"],
    ["mb35-mounting-bracket", "MB35 Mounting Bracket"],
    ["mb7", "MB7 Micro Motor Bracket"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "MB-17 Mounting Bracket For Super Duty Actuators"],
    ["synchronous-control-board", "Actuator Control Board with LCD Screen Interface"],
    ["rocker-switch-momentary" , "Momentary Rocker Switches for Linear Actuators"],
    ["rocker-switch-sustaining", "Sustaining Rocker Switches for Linear Actuators"],
    ["toggle-switch-momentary", "Momentary Toggle Switch for Actuators"],
    ["toggle-switch-sustaining", "Sustaining Toggle Switch for Actuators"],
    ["two-channel-remote-control-system", "Two Channel Remote Control System"],
    ["four-channel-remote-control-system", "Four Channel Remote Control System"],
    ["external-limit-switch-kit-for-actuators", "External Limit-Switch Microswitch Kit"],
    ["dc-power-adaptor", "DC Power Adaptor 12v"],
    ["ac-to-dc-power-adaptor-12v-30a", "Water Resistant LED Power Supply"],
    ["mb18-mounting-brackets", "MB18 Mounting Bracket"]
]);
//doesnt have mb-18
const FBTPriceMap = new Map([
    ["mb1-bracket", "$7.60 USD"],
    ["mb6", "$9.75 USD"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "$17.85 USD"],
    ["mb1-p", "$8.80 USD"],
    ["mb3u", "$10.30 USD"],
    ["mb3", "$8.00 USD"],
    ["mb5",  "$18.15 USD"],
    ["mb2", "$6.90 USD"],
    ["mb-pb-premium-base-mounting-bracket", "$8.65 USD"],
    ["mb8-bracket", "$13.80 USD"],
    ["mb14-bracket", "$6.25 USD"],
    ["mb9-bracket", "$6.80 USD"],
    ["mb6-p-bracket", "$9.75 USD"],
    ["mb50u-mounting-bracket", "$16.10 USD"],
    ["mb36sm", "$9.25 USD"],
    ["mb50", "$21.25 USD"],
    ["pulley-lifting-cables-for-linear-actuators", "$18.00 USD"],
    ["mb36", "$16.25 USD"],
    ["mb36c", "$11.25 USD"],
    ["mb50c", "$8.75 USD"],
    ["mb35-mounting-bracket", "$11.25 USD"],
    ["mb7", "$3.00 USD"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "$11.80 USD"],
    ["synchronous-control-board", "$155.95 USD"],
    ["rocker-switch-momentary" , "$4.20 USD"],
    ["rocker-switch-sustaining", "$4.20 USD"],
    ["toggle-switch-momentary", "$12.00 USD"],
    ["toggle-switch-sustaining", "$12.00 USD"],
    ["two-channel-remote-control-system", "$58.00 USD"],
    ["four-channel-remote-control-system", "$69.00 USD"],
    ["external-limit-switch-kit-for-actuators", "$19.80 USD"],
    ["dc-power-adaptor", "$48.00 USD"],
    ["ac-to-dc-power-adaptor-12v-30a", "$88.00 USD"],
    ["mb18-mounting-brackets", "$11.80 USD"]
]);
const FBTImageMap = new Map([
    ["mb1-bracket", "https://cdn.shopify.com/s/files/1/0615/2193/files/MB1_2_1280x_1.webp?v=1699567868"],
    ["mb6", "https://cdn.shopify.com/s/files/1/0615/2193/files/MB6_0d8cf65a-3c66-4917-afea-db422a69de66_800x_1.webp?v=1699568109"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "https://cdn.shopify.com/s/files/1/0615/2193/products/image0_22_1280x.jpg?v=1622240178"],
    ["mb1-p", "//cdn.shopify.com/s/files/1/0615/2193/products/MB1_1_de63d421-2114-48cf-9576-b835b39bd4d4_300x300.jpg?v=1495598484"],
    ["mb3u", "//cdn.shopify.com/s/files/1/0615/2193/products/MB3U_3_300x300.jpg?v=1617728234"],
    ["mb3", "//cdn.shopify.com/s/files/1/0615/2193/products/MB3_1_300x300.jpg?v=1596130635"],
    ["mb5",  "//cdn.shopify.com/s/files/1/0615/2193/products/MB5_cropped_aa50f050-da9b-47a5-901a-1bf800cac563_300x300.jpg?v=1674769435"],
    ["mb2", "//cdn.shopify.com/s/files/1/0615/2193/products/MB2_1_300x300.jpg?v=1596130641"],
    ["mb-pb-premium-base-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/Premium_Base_Bracket_300x300.jpg?v=1551725579"],
    ["mb8-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB8_Cropped_300x300.jpg?v=1596130687"],
    ["mb14-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB14_3_300x300.jpg?v=1596130649"],
    ["mb9-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB9_408ffe6d-9537-4a99-85f5-9b9593e60ab7_300x300.jpg?v=1596130711"],
    ["mb6-p-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/image0_29_300x300.jpg?v=1622237009"],
    ["mb50u-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB50U5_300x300.jpg?v=1622060559"],
    ["mb36sm", "//cdn.shopify.com/s/files/1/0615/2193/products/BDQE2902_300x300.jpg?v=1596130609"],
    ["mb50", "//cdn.shopify.com/s/files/1/0615/2193/products/DAYW3403_300x300.jpg?v=1596130589"],
    ["pulley-lifting-cables-for-linear-actuators", "//cdn.shopify.com/s/files/1/0615/2193/products/lifting_pulley_cable_300x300.jpg?v=1596131162"],
    ["mb36", "//cdn.shopify.com/s/files/1/0615/2193/products/YIIX1658_300x300.jpg?v=1596130625"],
    ["mb36c", "//cdn.shopify.com/s/files/1/0615/2193/products/LQFK7531-Recovered_300x300.jpg?v=1596130613"],
    ["mb50c", "//cdn.shopify.com/s/files/1/0615/2193/products/AJLI5797_300x300.jpg?v=1596130668"],
    ["mb35-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB351_300x300.jpg?v=1647380840"],
    ["mb7", "//cdn.shopify.com/s/files/1/0615/2193/products/Jan_29-Select-Hi_Res-28_300x300.jpg?v=1596130679"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "//cdn.shopify.com/s/files/1/0615/2193/products/mb17_300x300.jpg?v=1679346170"],
    ["synchronous-control-board", "//cdn.shopify.com/s/files/1/0615/2193/files/Syncboard_1_1_-min_1600x_1.webp?v=1700161531"],
    ["rocker-switch-momentary" , "//cdn.shopify.com/s/files/1/0615/2193/files/rocker-switch_1.webp?v=1701297255"],
    ["rocker-switch-sustaining", "//cdn.shopify.com/s/files/1/0615/2193/files/rocker-switch_1.webp?v=1701297255"],
    ["toggle-switch-momentary", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-Toogle_1728x_1.webp?v=1701297635"],
    ["toggle-switch-sustaining", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-Toogle_1728x_1.webp?v=1701297635"],
    ["two-channel-remote-control-system", "//cdn.shopify.com/s/files/1/0615/2193/files/2CH-REMOTE-CONTROL-OP_360x_53e3fb57-7672-4d07-a0e3-fa4d63f1bf00.webp?v=1701298439"],
    ["four-channel-remote-control-system", "//cdn.shopify.com/s/files/1/0615/2193/files/4CH-RC_1944x_1.webp?v=1701303114"],
    ["external-limit-switch-kit-for-actuators", "//cdn.shopify.com/s/files/1/0615/2193/files/EL-kit.webp?v=1701466060"],
    ["dc-power-adaptor", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-PA-12V-12A_1600x_1.webp?v=1701712697"],
    ["ac-to-dc-power-adaptor-12v-30a", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-PA-12V-30A-IP66_Power_Supply_1600x_1.webp?v=1701716576"],
    ["mb18-mounting-brackets", "//cdn.shopify.com/s/files/1/0615/2193/files/mb-18_1600x_8aff5223-d233-4d8b-81f0-999184666f2b.webp?v=1715792253"]
]);
const FBTIDMap = new Map([
    ["mb1-bracket", "846046107"],
    ["mb6", "846076519"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "32782018248775"],
    ["mb1-p", "19021824838"],
    ["mb3u", "846062783"],
    ["mb3", "846058147"],
    ["mb5",  "846068151"],
    ["mb2", "846053951"],
    ["mb8-bracket", "874080583"],
    ["mb14-bracket", "23445096966"],
    ["mb9-bracket", "874087643"],
    ["mb6-p-bracket", "32828360949831"],
    ["mb50u-mounting-bracket", "39343435644999"],
    ["mb36sm", "16289307820103"],
    ["mb50", "16289500594247"],
    ["pulley-lifting-cables-for-linear-actuators", "874171311"],
    ["mb36", "16289457799239"],
    ["mb36c", "16289389281351"],
    ["mb50c", "16289439612999"],
    ["mb35-mounting-bracket", "39621377753159"],
    ["mb7", "874079323"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "39960610046023"],
    ["synchronous-control-board", "31598239252551"],
    ["rocker-switch-momentary", "874172787"],
    ["rocker-switch-sustaining", "942475735"],
    ["toggle-switch-momentary", "1214504987"],
    ["toggle-switch-sustaining", "1214511515"],
    ["two-channel-remote-control-system", "874104623"],
    ["four-channel-remote-control-system", "874106639"],
    ["external-limit-switch-kit-for-actuators", "874111507"],
    ["dc-power-adaptor", "874099567"],
    ["ac-to-dc-power-adaptor-12v-30a", "12713991897159"],
    ["mb18-mounting-brackets", "40322792194119"]


    //fg-product-form__variant-group uk-fieldset js-product-variants
]);